export const tool = "ai-face-editor" as const;
export const frameCostPerFaceEdit = 1;

/* Placeholder to be compatible with the template */
